import { render, staticRenderFns } from "./DocumentSummary.vue?vue&type=template&id=7b942331&scoped=true"
import script from "./DocumentSummary.vue?vue&type=script&lang=ts"
export * from "./DocumentSummary.vue?vue&type=script&lang=ts"
import style0 from "./DocumentSummary.vue?vue&type=style&index=0&id=7b942331&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b942331",
  null
  
)

export default component.exports